// Polna · karta produktu (wzór P1 „podział na pół”) · jeden skrypt dla wszystkich kart, dane z osadzonego JSON produktu
// (w Shopify: {{ product | json }}). Galeria, konfigurator, cena, pasek zakupu, 3D na żądanie.
import * as Cart from 'polna/koszyk';
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const body = document.body;
const P = JSON.parse($('#product-json').textContent);
const KIND = body.dataset.kind; // tom | komplet | zestaw | sub
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
const zl = Cart.zl;
const VIEWKIND = { cutout: 'front', open: 'open', round: 'detail', set: 'set' };

const state = { view: 0, mode: 'once', qty: 1, variant: P.variants[0], tom: Number(body.dataset.tom) };
const fig = $('.figure'), hero = $('#hero-img'), form = $('#buy');
// cena subskrypcji z panelu (wariant produktu subskrypcja, data-price przy opcji), bez wartości w kodzie
const SUBP = (() => { const v = Number($('input[name="mode"][value="sub"]', form)?.dataset.price); return v > 0 ? v : null; })();

/* ---------- galeria ---------- */
let swapToken = 0;
function showView(i, animate = true) {
  i = (i + P.images.length) % P.images.length;
  state.view = i;
  const im = P.images[i], token = ++swapToken;
  $$('[data-view-btn]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.viewBtn) === i)));
  $$('[data-view-index]').forEach(e => { e.textContent = String(i + 1).padStart(2, '0'); });
  $('[data-view-caption]').textContent = `Widok: ${im.label.toLowerCase()}`;
  const apply = () => {
    if (token !== swapToken) return;
    hero.srcset = im.srcset; hero.src = im.src; hero.width = im.width; hero.height = im.height; hero.alt = im.alt;
    fig.dataset.view = VIEWKIND[im.kind] || 'front';
    const done = () => { if (token === swapToken) hero.classList.remove('is-fading'); };
    hero.complete ? requestAnimationFrame(done) : hero.addEventListener('load', done, { once: true });
  };
  if (!animate || reduce) { apply(); return; }
  const pre = new Image(); pre.sizes = hero.sizes; pre.srcset = im.srcset; pre.src = im.src;
  hero.classList.add('is-fading');
  const go = () => setTimeout(apply, 180);
  (pre.decode ? pre.decode() : Promise.resolve()).then(go, go);
}
$$('[data-view-btn]').forEach(b => b.addEventListener('click', () => { if (Number(b.dataset.viewBtn) !== state.view) showView(Number(b.dataset.viewBtn)); }));
$('.thumbs')?.addEventListener('keydown', e => {
  if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
  e.preventDefault(); showView(state.view + (e.key === 'ArrowRight' ? 1 : -1)); $(`[data-view-btn="${state.view}"]`)?.focus();
});
// przesunięcie palcem po zdjęciu
{ let x0 = null; fig.addEventListener('pointerdown', e => { x0 = e.clientX; }); fig.addEventListener('pointerup', e => { if (x0 === null) return; const d = e.clientX - x0; x0 = null; if (Math.abs(d) > 40) showView(state.view + (d < 0 ? 1 : -1)); }); }

/* ---------- warianty z kolorem tomu (zestaw, subskrypcja) ---------- */
function setTomColor(t) {
  t = Number(t); state.tom = t; body.dataset.tom = String(t);
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', t === 1 ? '#1E3A2B' : '#4E1B21');
  const st = $('[data-sticky-img]'); if (st && st.dataset['img' + t]) st.src = st.dataset['img' + t];
}
function setVariant(id) {
  state.variant = Cart.variant(P, id);
  if (state.variant.kolor) setTomColor(state.variant.kolor === 'bordo' ? 2 : 1);
  const imgId = state.variant.image || (state.variant.kolor === 'bordo' ? 'burgundy-front' : state.variant.kolor ? 'green-front' : null);
  const idx = P.images.findIndex(im => im.id === imgId);
  if (idx >= 0 && idx !== state.view) showView(idx);
}

/* ---------- cena ---------- */
const addonsSum = () => $$('input[name="addon"]:checked', form).reduce((a, i) => a + Number(i.dataset.price || 0), 0);
const freq = () => $('input[name="freq"]:checked', form)?.value || '28'; // co 28 dni (jedna opcja)
function unit() {
  if (state.gift) return state.gift.price;
  if (KIND === 'tom') return state.mode === 'sub' ? (SUBP ?? state.variant.price) : state.variant.price;
  return state.variant.price;
}
function renderPrice() {
  const u = unit(), total = (u + addonsSum()) * state.qty, f = freq();
  $('[data-price]').textContent = zl(u);
  const note = $('[data-price-note]');
  if (state.gift) note.textContent = state.gift.solo > state.gift.price ? `zamiast ${zl(state.gift.solo)} osobno` : 'dostawa gratis';
  else if (KIND === 'tom') note.textContent = state.mode === 'once' ? 'jednorazowo, z VAT' : `za tom w subskrypcji, co ${f} dni`;
  else if (gift.note0 !== null) note.textContent = gift.note0;
  if (KIND === 'sub') note.textContent = `za tom, co ${f} dni, dostawa gratis`;
  $('[data-sum]').textContent = zl(total);
  const sp = $('[data-sticky-price]'); if (sp) sp.textContent = zl(total);
  const sm = $('[data-sticky-mode]');
  if (sm) sm.textContent = state.gift ? `Zestaw prezentowy ${state.gift.n}+${state.gift.n}` : KIND === 'sub' || (KIND === 'tom' && state.mode === 'sub') ? `subskrypcja co ${f} dni` : KIND === 'zestaw' ? state.variant.title : 'jednorazowo';
  if (KIND === 'tom') {
    const calc = $('[data-sub-calc]'), once = Number(state.variant.price), sp = SUBP ?? once;
    const n = 13, tt = n => (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 'tomy' : 'tomów');
    if (calc) {
      const yr = Math.round(n * (once - sp));
      calc.hidden = !(state.mode === 'sub' && yr > 0);
      calc.innerHTML = yr > 0 ? `Subskrybuj i oszczędź <b>${zl(yr)}</b> w ciągu roku (${n} ${tt(n)})` : '';
    }
    const sumEl = $('[data-sum]'), addBtn = $('[data-add]');
    if (sumEl && addBtn) { sumEl.hidden = state.mode === 'sub'; }
  }
  if (KIND === 'sub') {
    const n = 13; // 365 / 28
    const t = n => (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 'tomy' : 'tomów');
    const el = $('[data-sub-calc]'), sp = Number(state.variant.price), base = Number(state.variant.compare_at_price || el?.dataset.base || 0);
    if (el) el.innerHTML = base > sp ? `<b>${n}</b> ${t(n)} w roku, oszczędzasz <b>${zl(n * (base - sp))}</b>` : `<b>${n}</b> ${t(n)} w roku`;
  }
}

/* ---------- zdarzenia formularza ---------- */
form.addEventListener('change', e => {
  const el = e.target;
  if (el.name === 'mode') state.mode = el.value;
  if (el.name === 'freq' && KIND === 'tom') { $('input[name="mode"][value="sub"]', form).checked = true; state.mode = 'sub'; }
  if (el.name === 'variant') setVariant(el.value);
  if (el.name === 'qty') state.qty = clampQty(el.value);
  if (el.name === 'gift_mode' || el.name === 'gift_size') setGift();
  renderPrice();
});
const qtyInput = $('[data-qty-input]');
const clampQty = v => Math.min(20, Math.max(1, parseInt(v, 10) || 1));
$$('[data-qty]').forEach(b => b.addEventListener('click', () => { state.qty = clampQty(state.qty + Number(b.dataset.qty)); qtyInput.value = state.qty; renderPrice(); }));
qtyInput?.addEventListener('input', () => { state.qty = clampQty(qtyInput.value); renderPrice(); });
qtyInput?.addEventListener('blur', () => { qtyInput.value = state.qty; });
// bilecik: licznik znaków
const note = $('[data-note]'), noteCount = $('[data-note-count]');
note?.addEventListener('input', () => { noteCount.textContent = `${note.value.length} / ${note.maxLength}`; });

/* ---------- do koszyka ---------- */
function addToCart(openDrawer = true) {
  const q = state.qty; const jobs = [];
  let label = P.title;
  if (state.gift) {
    const props = {};
    const t = gift.note?.value.trim(); if (t) props['Bilecik'] = t;
    if ($('[name="gift_noprice"]', form)?.checked) props['Bez ceny'] = 'Tak';
    jobs.push(Cart.add({ handle: gift.handle, variant_id: state.gift.id, quantity: q, properties: props }, { openDrawer }));
    label = `Zestaw prezentowy ${state.gift.n}+${state.gift.n}`;
    $('[data-status]').textContent = `Dodano do koszyka: ${label}, ${q} szt.`;
    return Promise.all(jobs);
  }
  if (KIND === 'tom' && state.mode === 'sub') {
    const sp = Cart.product('subskrypcja');
    const v = sp.variants.find(x => x.kolor === (state.tom === 2 ? 'bordo' : 'green'));
    jobs.push(Cart.add({ handle: 'subskrypcja', variant_id: v.id, quantity: q, selling_plan: freq() }, { openDrawer }));
    label = `Subskrypcja, start: ${P.title}`;
  } else if (KIND === 'sub') {
    jobs.push(Cart.add({ handle: P.handle, variant_id: state.variant.id, quantity: q, selling_plan: freq() }, { openDrawer }));
  } else if (KIND === 'zestaw') {
    const props = {};
    if (note?.value.trim()) props['Bilecik'] = note.value.trim();
    if ($('[name="noprice"]', form)?.checked) props['Bez ceny w paczce'] = 'Tak';
    jobs.push(Cart.add({ handle: P.handle, variant_id: state.variant.id, quantity: q, properties: props }, { openDrawer }));
    label = `${P.title}, ${state.variant.title}`;
  } else {
    jobs.push(Cart.add({ handle: P.handle, variant_id: state.variant.id, quantity: q }, { openDrawer }));
  }
  $$('input[name="addon"]:checked', form).forEach(i => jobs.push(Cart.add({ handle: i.value, quantity: q, properties: { 'Do tomu': P.title } }, { openDrawer: false })));
  $('[data-status]').textContent = `Dodano do koszyka: ${label}, ${q} szt.`;
  return Promise.all(jobs);
}
form.addEventListener('submit', e => { e.preventDefault(); Cart.ready.then(() => addToCart(true)); });
$('[data-buy-now]')?.addEventListener('click', () => Cart.ready.then(() => { addToCart(false).then(() => { location.href = '/checkout'; }); }));
const stickyBtn = $('[data-sticky-add]');
stickyBtn?.addEventListener('click', () => Cart.ready.then(() => {
  if (!form.reportValidity()) { form.scrollIntoView({ behavior: 'smooth' }); return; }
  addToCart(true);
}));

/* ---------- pasek zakupu po przewinięciu poza przyciski ---------- */
const sticky = $('[data-sticky]'), actionsEl = $('[data-actions]');
const vis = { top: true, foot: false };
function renderSticky() { const on = !vis.top && !vis.foot; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', String(!on)); stickyBtn.tabIndex = on ? 0 : -1; if (on) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', ''); }
let stickyRaf = 0;
const checkTop = () => { stickyRaf = 0; vis.top = actionsEl.getBoundingClientRect().bottom > 0; renderSticky(); };
addEventListener('scroll', () => { if (!stickyRaf) stickyRaf = requestAnimationFrame(checkTop); }, { passive: true });
addEventListener('resize', checkTop); checkTop();
new IntersectionObserver(([e]) => { vis.foot = e.isIntersecting; renderSticky(); }).observe($('.footer'));

/* opinie renderuje Liquid (aplikacja opinii albo metaobiekty opinia) */

/* ---------- 3D: Three.js + Draco + GLB v4 ładowane dopiero po kliknięciu ---------- */
let viewer3d = null;
const dlg = $('#viewer'), loadMsg = $('[data-viewer-load]');
$('[data-open-3d]')?.addEventListener('click', async () => {
  dlg.showModal();
  if (!viewer3d) {
    loadMsg.hidden = false; loadMsg.textContent = 'Ładowanie modelu…';
    try { viewer3d = await createViewer($('[data-viewer-stage]'), P.metafields.model_3d); window.__viewer3d = viewer3d; }
    catch (err) { loadMsg.hidden = false; loadMsg.textContent = 'Nie udało się wczytać modelu 3D.'; console.warn(err); }
  } else viewer3d.resume();
});
$('[data-close-3d]')?.addEventListener('click', () => dlg.close());
dlg?.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });
dlg?.addEventListener('close', () => viewer3d?.pause());

async function createViewer(stage, url) {
  const THREE = await import('three');
  const [{ GLTFLoader }, { DRACOLoader }, { RoomEnvironment }] = await Promise.all([
    import('three/addons/loaders/GLTFLoader.js'), import('three/addons/loaders/DRACOLoader.js'), import('three/addons/environments/RoomEnvironment.js'),
  ]);
  const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: true });
  renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping; renderer.toneMappingExposure = 1.05;
  stage.appendChild(renderer.domElement);
  const scene = new THREE.Scene();
  const pmrem = new THREE.PMREMGenerator(renderer), room = new RoomEnvironment();
  scene.environment = pmrem.fromScene(room, 0.03).texture; scene.environmentIntensity = 0.6; room.dispose(); pmrem.dispose();
  const cam = new THREE.PerspectiveCamera(30, 1, 0.01, 50);
  scene.add(new THREE.HemisphereLight(0xfff3df, 0x374339, 0.6));
  for (const [c, i, pos] of [[0xfff5df, 2.2, [-4, 6, 9]], [0xffecd2, 1.6, [8, 2, -4]], [0xebf0ff, 0.6, [5, -2, 9]]]) { const l = new THREE.DirectionalLight(c, i); l.position.fromArray(pos); scene.add(l); }
  const loader = new GLTFLoader().setDRACOLoader(new DRACOLoader().setDecoderPath((window.Polna && window.Polna.draco) || '/assets/').setDecoderConfig({ type: 'js' }));
  const root = new THREE.Group(); scene.add(root);
  const g = await loader.loadAsync(url);
  const o = g.scene;
  // strony z nadrukiem (sudoku, krzyżówka, wyklejka) bez cieniowania, żeby druk był czytelny
  o.traverse(m => {
    if (!m.isMesh) return;
    const fix = mat => (/^(Sudoku_01|Crossword_01_PL|Cream_Endpaper)$/.test(mat.name)
      ? new THREE.MeshBasicMaterial({ name: mat.name + '_Print', map: mat.map, side: mat.side, toneMapped: false, polygonOffset: true, polygonOffsetFactor: -1, polygonOffsetUnits: -1 }) : mat);
    m.material = Array.isArray(m.material) ? m.material.map(fix) : fix(m.material);
  });
  const box = new THREE.Box3().setFromObject(o), c = box.getCenter(new THREE.Vector3()), size = box.getSize(new THREE.Vector3());
  const s = 1 / size.y;
  const norm = new THREE.Group(); norm.scale.setScalar(s); norm.position.copy(c).multiplyScalar(-s); norm.add(o);
  const book = new THREE.Group(); book.add(norm); root.add(book);
  const hinge = o.getObjectByName('CoverFrontPivot');
  const pages = []; o.getObjectByName('PageRight')?.traverse(x => { if (x.morphTargetInfluences?.length) pages.push(x); });
  const width = size.x * s;
  let rx = 0.08, ry = -0.55, vx = 0, vy = 0, drag = null, running = true, cover = 0, coverTarget = 0;
  // otwieranie wg REPORT-v4: CoverFrontPivot.rotation.y = -PI * progress oraz PageRight.morphTargetInfluences[0] = progress
  function applyCover() {
    const e = cover < .5 ? 2 * cover * cover : 1 - Math.pow(-2 * cover + 2, 2) / 2;
    if (hinge) hinge.rotation.y = -Math.PI * e;
    pages.forEach(p => { p.morphTargetInfluences[0] = e; });
    book.position.x = width * 0.5 * e;
  }
  function fit() {
    const w = stage.clientWidth || 1, h = stage.clientHeight || 1;
    renderer.setSize(w, h, false); cam.aspect = w / h;
    const fitH = 1.6 / (2 * Math.tan(THREE.MathUtils.degToRad(15))), fitW = 2.0 / (2 * Math.tan(THREE.MathUtils.degToRad(15)) * cam.aspect);
    cam.position.set(0, 0, Math.max(fitH, fitW)); cam.lookAt(0, 0, 0); cam.updateProjectionMatrix();
  }
  new ResizeObserver(fit).observe(stage); fit();
  stage.addEventListener('pointerdown', e => { drag = { x: e.clientX, y: e.clientY }; stage.setPointerCapture(e.pointerId); stage.style.cursor = 'grabbing'; vx = vy = 0; });
  stage.addEventListener('pointermove', e => { if (!drag) return; vy = (e.clientX - drag.x) * 0.009; vx = (e.clientY - drag.y) * 0.006; drag = { x: e.clientX, y: e.clientY }; ry += vy; rx = Math.max(-0.8, Math.min(0.8, rx + vx)); });
  const end = () => { drag = null; stage.style.cursor = ''; };
  stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end);
  stage.tabIndex = 0; stage.setAttribute('aria-label', 'Model 3D książki. Strzałki obracają.');
  stage.addEventListener('keydown', e => { const k = { ArrowLeft: [0, -0.25], ArrowRight: [0, 0.25], ArrowUp: [-0.15, 0], ArrowDown: [0.15, 0] }[e.key]; if (k) { e.preventDefault(); rx = Math.max(-0.8, Math.min(0.8, rx + k[0])); ry += k[1]; } });
  const coverBtn = $('[data-cover]'); coverBtn.hidden = false;
  const setCover = on => { coverTarget = on ? 1 : 0; coverBtn.setAttribute('aria-pressed', String(on)); coverBtn.textContent = on ? 'Zamknij okładkę' : 'Otwórz okładkę'; if (on && Math.abs(ry) > 0.9) ry = -0.35; };
  coverBtn.addEventListener('click', () => setCover(!coverTarget));
  function tick() {
    if (!running) return;
    if (!drag) { ry += vy; rx = Math.max(-0.8, Math.min(0.8, rx + vx)); vy *= 0.92; vx *= 0.92; }
    if (cover !== coverTarget) { cover = reduce ? coverTarget : cover + Math.sign(coverTarget - cover) * Math.min(Math.abs(coverTarget - cover), 0.03); applyCover(); }
    root.rotation.set(rx, ry, 0); renderer.render(scene, cam); requestAnimationFrame(tick);
  }
  loadMsg.hidden = true; requestAnimationFrame(tick);
  return {
    pause: () => { running = false; }, resume: () => { if (!running) { running = true; requestAnimationFrame(tick); } },
    setCover, state: () => ({ cover, hinge: hinge?.rotation.y, morph: pages[0]?.morphTargetInfluences[0], pages: pages.length }),
  };
}

/* ---------- opcja prezentowa: Dla siebie | Na prezent (zestaw-prezentowy, warianty 2+2 i 3+3) ---------- */
const gift = { box: $('[data-gift-toggle]'), panel: $('[data-gift-panel]'), note: $('#gift-note'), note0: null, t0: null, img0: null };
gift.handle = gift.box?.dataset.giftHandle || 'zestaw-prezentowy';
{
  const qs = new URLSearchParams(location.search);
  const role = window.Shopify?.theme?.role;
  const force = qs.get('gift') === 'force' && role !== 'main'; // tylko test, nigdy na motywie live
  gift.on = !!gift.box && (gift.box.dataset.giftLive === 'true' || force);
  if (gift.on) {
    gift.box.hidden = false;
    gift.note0 = $('[data-price-note]')?.textContent ?? null;
    const t = $('.title'); gift.t0 = t ? [t.children[0]?.textContent, t.children[1]?.textContent] : null;
    gift.note?.addEventListener('input', () => { $('[data-gift-count]').textContent = `${gift.note.value.length} / ${gift.note.maxLength}`; });
    const pre = qs.get('prezent'); // link bezpośredni ?prezent=22 albo 33
    if (pre === '22' || pre === '33') {
      $('input[name="gift_mode"][value="gift"]', form).checked = true;
      const r = $(`input[name="gift_size"][data-n="${pre[0]}"]`, form); if (r) r.checked = true;
    }
  }
}
function setGift() {
  if (!gift.on) return;
  const on = $('input[name="gift_mode"]:checked', form)?.value === 'gift';
  const r = $('input[name="gift_size"]:checked', form);
  state.gift = on && r ? { id: r.value, n: Number(r.dataset.n), price: Number(r.dataset.price), solo: Number(r.dataset.solo) } : null;
  form.classList.toggle('is-gift', !!state.gift);
  body.classList.toggle('gift-on', !!state.gift);
  gift.panel.hidden = !state.gift;
  $$('.opt-tom, .opt-mode, .opt-freq, .opt-add:not(.gift-noprice)', form).forEach(el => { if (!el.closest('[data-gift-toggle]')) el.hidden = !!state.gift; });
  const t = $('.title');
  if (t && gift.t0) { t.children[0].textContent = state.gift ? 'Zestaw prezentowy' : gift.t0[0]; t.children[1].textContent = state.gift ? `${state.gift.n}+${state.gift.n}` : gift.t0[1]; }
  $$('[data-gift-n]', gift.panel).forEach(b => { b.textContent = `${state.gift ? state.gift.n : 2} szt.`; });
  // galeria: render stosu tomów v5 (bez pudełka); powrót do bieżącego widoku
  if (state.gift) { if (!gift.img0) gift.img0 = true; hero.srcset = ''; hero.src = gift.box.dataset.giftImg; fig.dataset.view = 'set'; }
  else if (gift.img0) { gift.img0 = null; showView(state.view, false); }
}

/* ---------- start ---------- */
Cart.ready.then(() => {
  const sel = $('input[name="variant"]:checked', form);
  if (sel) state.variant = Cart.variant(P, sel.value);
  setGift(); renderPrice();
});
setGift(); renderPrice();
